export default __webpack_public_path__ + "static/media/close-modal.b9ba26c7.svg";